import Api from '@api/setMealManage'
import mainStore from '@components/Main/store'
import { getMerchantInfo } from '@util'
import { isSiDaProperty } from '@merchant-backend/util'
import { Modal } from 'hljd'
import cloneDeep from 'lodash/cloneDeep'
import _get from 'lodash/get'
import { action, computed, observable, runInAction, toJS } from 'mobx'

export default class {
  constructor(centerStore) {
    this.centerStore = centerStore
    this.property_id = this.centerStore.property_id
  }

  @computed
  get weddingPhotoType() {
    return this.centerStore.weddingPhotoType
  }

  @observable
  form_values = {
    earnest_money_support: '2',
    pay_all_percent: '0',
    actual_price: '',
    scenicSpot: []
  }

  @observable seriesList = []
  @observable vipTagList = []

  @observable historyOrderGift = [] // 历史订单礼提示列表
  @observable historyPayAllGift = [] // 历史全款礼提示列表

  @observable payWayModal = false // 四大商家订金支付协议Modal

  @observable scenicSpotList = [] // 取景地列表

  merchant_info = JSON.parse(sessionStorage.getItem('merchant_info'))
  form = {}

  @observable secondCategoryList = [] // 二级分类列表(部分商家有)

  /** 获取二级分类 */
  getSecondCategoryList = async () => {
    const { id, isDraft } = this.centerStore
    const { success, data } = await Api.getSecondCategory({
      propertyId: this.property_id,
      id: isDraft ? '' : id
    })
    if (success) {
      this.secondCategoryList = data
      const secondCategoryId =
        this.centerStore.second_category_id || _get(data, '[0].id', '')
      this.centerStore.second_category_id = secondCategoryId
      this.centerStore.weddingPhotoType = secondCategoryId
    }
  }

  /** 获取套餐订单礼全款礼历史数据 */
  getOrderAndPayAllGiftHistory = async () => {
    const { success, data } = await Api.orderAndPayAllGiftHistory()
    if (success && data) {
      const {
        historyOrderGift,
        historyPayAllGift,
        newOrderGift,
        newPayAllGift
      } = data
      this.historyOrderGift = [...new Set(historyOrderGift || [])]
      this.historyPayAllGift = [...new Set(historyPayAllGift || [])]
      if (!this.centerStore.id) {
        // 非编辑状态
        this.form_values.order_gift = newOrderGift
        this.form.setFieldsValue({
          order_gift: newOrderGift
        })

        if (newPayAllGift) {
          this.form_values.pay_all_percent = String(newPayAllGift.type)
          this.form_values.pay_all_gift = String(newPayAllGift.content)
          this.form.setFieldsValue({
            pay_all_percent: String(newPayAllGift.type),
            pay_all_gift: String(newPayAllGift.content)
          })
        }
        this.centerStore.oldFormatData = this.centerStore.getFormatValues()
      }
    }
  }

  afterGetDetail = detail => {
    detail = cloneDeep(detail)
    detail.earnest_money_support = +detail.earnest_money ? '2' : '1'
    detail.pay_all_percent = detail.pay_all_gift ? '2' : detail.pay_all_percent
    detail.vip_tag_list = (detail.vip_tag_list || []).map(item => item.mark_id)
    detail.scenicSpotImg = detail.scenic_spot
    detail.scenicSpot = (toJS(detail.scenic_spot) || []).map(i => i.id)
    this.form_values = detail

    // 若详情为旅拍则重新搜索选中的目的地取景地+
  }

  handleSearchMarkId = list => {
    let markId
    list.forEach(el => {
      if ((el.id === 3377 || el.id === 3421) && el.children) {
        const index = el.children.findIndex(f => f.isActive)
        if (index !== -1) {
          markId = el.children[index]['mark_id']
        }
      }
    })
    return markId
  }

  initTags = (tagIds, tag_list) => {
    if (!tag_list) {
      return []
    }
    if (!tagIds || tagIds.length == 0) {
      return [...toJS(tag_list)]
    }

    const tags = tagIds.map(item => item.mark_id)
    const tempTags = [...toJS(tag_list)]
    for (let i = 0; i < tempTags.length; i++) {
      for (let j = 0; j < tempTags[i].children.length; j++) {
        if (tags.includes(tempTags[i].children[j].mark_id)) {
          tempTags[i].children[j].isActive = true
        }
      }
    }
    return [...tempTags]
  }

  @action
  removeDeletedScenicSpotList = (selected = []) => {
    this.scenicSpotList.forEach((el, i) => {
      if (el.deleted) {
        const index = selected.findIndex(f => f === el.id)
        if (index === -1) {
          this.scenicSpotList.splice(i, 1)
        }
      }
    })
  }

  // 处理已被删除但是仍然有关联关系的取景地
  handleDeletedScenicSpotList = (list = [], detailList = []) => {
    const newList = list
      .map(el => {
        const index = detailList.findIndex(f => f.id === el.id)
        if (index === -1 && el.deleted) {
          return null
        } else {
          return el
        }
      })
      .filter(f => !!f)
    return newList
  }

  getSeriesList = async () => {
    const { success, data } = await Api.getSeriesList()
    if (success) {
      this.seriesList = data || []
    }
  }

  togglePayWayModal = bool => () => {
    this.payWayModal = bool
  }

  //表单改变
  @action
  onFormChange = values => {
    runInAction(() => {
      this.form_values = { ...this.form_values, ...values }
    })
  }

  /**
   * 校验套餐基本信息数据
   * @param {string} type draft-草稿  save-发布
   */
  validateData = () => {
    if (!this.customCheck()) {
      return false
    } else {
      let flag = true

      this.form.validateFieldsAndScroll((error, values) => {
        if (error) {
          flag = false
          this.scrollMain()
        } else {
          flag = true
        }
      })

      return flag
    }
  }

  /** 某些业务逻辑的校验 */
  customCheck = () => {
    const {
      earnest_money_support,
      earnest_money,
      order_gift,
      pay_all_percent,
      pay_all_gift,
      market_price,
      actual_price
    } = this.form_values
    let flag = true
    if (earnest_money_support === '2') {
      if (!earnest_money) {
        this.form.setFields({
          earnest_money: {
            value: earnest_money,
            errors: [
              new Error(`请填写${isSiDaProperty() ? '订金' : '定金'}金额`)
            ]
          }
        })
        flag = false
      } else {
        let reg = /^[1-9]\d*$/g
        if (!reg.test(+earnest_money)) {
          this.form.setFields({
            earnest_money: {
              value: earnest_money,
              errors: [new Error('请输入正整数')]
            }
          })
          flag = false
        }
        if (actual_price && +earnest_money > +actual_price) {
          this.form.setFields({
            earnest_money: {
              value: earnest_money,
              errors: [new Error('定金需小于现价')]
            }
          })
          flag = false
        }
      }
    }
    if (order_gift && order_gift.length > 15) {
      this.form.setFields({
        order_gift: {
          value: order_gift,
          errors: [new Error('内容不超过15个字')]
        }
      })
      flag = false
    }

    if (pay_all_percent == 2) {
      if (!pay_all_gift) {
        this.form.setFields({
          pay_all_gift: {
            value: pay_all_gift,
            errors: [new Error('请填写全款礼')]
          }
        })
        flag = false
      } else {
        if (pay_all_gift.length > 15) {
          this.form.setFields({
            pay_all_gift: {
              value: pay_all_gift,
              errors: [new Error('内容不超过15个字')]
            }
          })
          flag = false
        }
      }
    }
    if (market_price) {
      let reg = /^[1-9]\d*$/g
      if (!reg.test(market_price)) {
        this.form.setFields({
          market_price: {
            value: market_price,
            errors: [new Error('请输入正整数')]
          }
        })
        flag = false
      }
      if (+market_price < +this.form_values.actual_price) {
        this.form.setFields({
          market_price: {
            value: market_price,
            errors: [new Error('现价不能大于原价')]
          }
        })
        flag = false
      }
    }

    const title = this.form.getFieldValue('title')
    const cityCode = (getMerchantInfo() || {}).city_code
    if (cityCode == -2000 && title && !/测试/.test(title)) {
      Modal.error({
        title: '钓鱼岛商家套餐和案例必须带有“测试”词语'
      })
      flag = false
    }

    if (!flag) {
      this.goTop()
    }
    return flag
  }

  /** 提交时格式化第一步的数据 */
  formatStepOne = () => {
    const stepOneData = this.form_values

    if (Object.values(stepOneData).length < 1) return

    const scenic_spot = this.formatScenicSpot(
      stepOneData['scenicSpotImg'],
      stepOneData['scenicSpot']
    )

    const formatData = {
      ...stepOneData,
      earnest_money:
        stepOneData.earnest_money_support === '1'
          ? null
          : stepOneData.earnest_money,
      market_price: stepOneData.market_price ? stepOneData.market_price : 0,
      order_gift: stepOneData.order_gift,
      pay_all_gift:
        stepOneData.pay_all_percent == 2 ? stepOneData.pay_all_gift : null,
      pay_all_percent:
        stepOneData.pay_all_percent == 2
          ? undefined
          : +stepOneData.pay_all_percent,
      vip_tag_list:
        stepOneData.vip_tag_list && stepOneData.vip_tag_list.length
          ? stepOneData.vip_tag_list.join(',')
          : '',
      tag_list: '',
      scenic_spot: scenic_spot
    }

    if (this.weddingPhotoType == '4') {
      // 婚纱摄影类目，取旅拍目的地
      const tag_list = []
      const list = (this.centerStore.tag_list || []).filter(
        // 筛选旅拍的可选tag  国内-3377   国外-3421
        item => item.id == 3377 || item.id == 3421
      )

      for (let i = 0; i < list.length; i++) {
        for (let j = 0; j < list[i].children.length; j++) {
          if (list[i].children[j].isActive) {
            tag_list.push(list[i].children[j].mark_id)
          }
        }
      }
      formatData.tag_list = tag_list.join(',')
    }

    return formatData
  }

  scrollMain = () => {
    // TODO 校验放到最后的保存处
    const { contentMainDiv, scrollTopMain } = mainStore
    const { scrollTop } = contentMainDiv.current
    scrollTopMain(0, scrollTop - 75)
  }

  getForm = (name, value) => {
    this[name] = value
  }

  getVipTagList = async () => {
    const { data } = await Api.getVipTagList()
    this.vipTagList = data
  }

  /** 滚动到顶部 */
  goTop = () => {
    let { contentMainDiv } = mainStore
    let scrollTop = contentMainDiv.current.scrollTop
    let timer = setInterval(() => {
      //滚动到输入框的位置
      if (scrollTop <= 0) {
        clearInterval(timer)
      } else {
        scrollTop -= 35
        contentMainDiv.current && contentMainDiv.current.scrollTo(0, scrollTop)
      }
    }, 10)
  }

  // 全部取景地请求
  queryScenicSpotList = async (markId, type) => {
    let code
    if (!markId) {
      code = JSON.parse(sessionStorage.getItem('merchant_info')).city_code
    }
    const { data, success } = await Api.getScenicSpotList({
      cityCode: code,
      markId: markId
    })
    if (success) {
      // 判断是否为新建套餐，来展示没有被删除的取景地
      if (type === 'create') {
        // 新建时直接删除不存在的取景地
        this.scenicSpotList = this.handleDeletedScenicSpotList(data.list)
      } else {
        // 编辑时先不删除，根据详情返回后再判断是否删除
        this.scenicSpotList = data.list
      }
    }
  }

  @action
  resetScenicSpotList = () => {
    this.scenicSpotList = []
    if (this.form.getFieldValue('scenicSpot')?.length) {
      this.form_values['scenicSpot'] = []
      this.form.setFieldsValue({
        scenicSpot: []
      })
    }
  }

  @action
  resetScenicSpotImg = () => {
    if (!this.form.getFieldValue('scenicSpotImg')?.length) {
      return
    }
    this.form_values['scenicSpotImg'] = []
    this.form.setFieldsValue({
      scenicSpotImg: []
    })
  }

  selectedScenicSpot = (list = []) => {
    if (!this.form_values['scenicSpot']) {
      return
    }
    const ret = this.form_values['scenicSpot'].map(i => ({
      id: i,
      name: (list.find(f => f.id === i) || {}).name
    }))
    return ret
  }

  @action
  setScenicSpot = list => {
    this.scenicSpotList = list
  }

  // 提交时数据改为服务端所需数据
  formatScenicSpot = (allList = [], selected = []) => {
    let ret = []
    toJS(selected).forEach(el => {
      toJS(allList).forEach(item => {
        if (el === item.id) {
          ret.push(item)
        }
      })
    })
    return ret
  }
}
